<div v-if="showBreadCrumb" :class="[styles.breadcrumbsWrapper, {[styles.highlighted]: isHighlighted}]">
  <v-container >
    <v-breadcrumbs class="pa-0" :items="breadcrumbs">
      <template v-if="!isLoading" v-slot:item="{ item }">
        <a 
          v-if="item.external" 
          :href="item.href" 
          :disabled="item.disabled"
        >
          {{item.text}}
        </a>
  
        <v-breadcrumbs-item
          v-else
          :class="[styles.activeBreadcrumb, {[styles.disabled]: item.disabled}]"
          @click="onClickBreadcrumb(item)"
          :disabled="item.disabled"
        >
          {{item.text}}
        </v-breadcrumbs-item>
      </template>
      <v-breadcrumbs-item
        v-else
        v-for="i in 3"
        :key="i"
      >
        <v-skeleton-loader 
          loading
          type="text"
          width="150"
          height="14"
        />
      </v-breadcrumbs-item>
    </v-breadcrumbs>
  </v-container>
</div>